import script from "./AppColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./AppColumn.vue?vue&type=script&setup=true&lang=js"

import "./AppColumn.vue?vue&type=style&index=0&id=787f50b8&scroped=true&lang=css"

const __exports__ = script;

export default __exports__